var map = {
	"./Sonar-dark.svg": 3020,
	"./Sonar.svg": 73975,
	"./ada-dark.svg": 52231,
	"./ada.svg": 58846,
	"./analysis.png": 20863,
	"./android-dark.svg": 96496,
	"./android.svg": 40019,
	"./assembly.png": 89081,
	"./c++.svg": 96323,
	"./c.svg": 99009,
	"./c3.svg": 84336,
	"./carbon.png": 4422,
	"./circt.svg": 48289,
	"./clean.svg": 74445,
	"./cmake.svg": 55851,
	"./crystal-dark.svg": 31233,
	"./crystal.svg": 99644,
	"./cuda-dark.svg": 72448,
	"./cuda.svg": 32099,
	"./d.svg": 81630,
	"./dart.svg": 67469,
	"./dotnet.svg": 34892,
	"./elixir.svg": 45963,
	"./erlang.svg": 60975,
	"./fortran.svg": 6004,
	"./fsharp.svg": 86856,
	"./gimple.svg": 66076,
	"./glsl-dark.svg": 76067,
	"./glsl.svg": 54162,
	"./go.svg": 16288,
	"./haskell.png": 91097,
	"./hlsl.png": 74228,
	"./hook-dark.png": 17883,
	"./hook.png": 69384,
	"./hylo.svg": 44060,
	"./ispc.png": 17078,
	"./java.svg": 38478,
	"./js.svg": 9019,
	"./julia.svg": 97545,
	"./kotlin.svg": 62033,
	"./llvm.png": 5206,
	"./mlir.svg": 11796,
	"./mojo.svg": 60363,
	"./nim.svg": 48826,
	"./nix.svg": 999,
	"./numba.svg": 44169,
	"./ocaml.svg": 88290,
	"./odin.png": 69233,
	"./opencl-dark.svg": 33300,
	"./opencl.svg": 24751,
	"./pascal-dark.svg": 53067,
	"./pascal.svg": 6442,
	"./pony.svg": 65198,
	"./python.svg": 70964,
	"./racket.svg": 37640,
	"./ruby.svg": 20390,
	"./rust-dark.svg": 57565,
	"./rust.svg": 7648,
	"./sail.svg": 78097,
	"./scala.png": 42915,
	"./slang-dark.svg": 23738,
	"./slang.svg": 7737,
	"./snowball.svg": 99836,
	"./solidity.svg": 4633,
	"./spice.png": 83955,
	"./spirv-dark.svg": 59341,
	"./spirv.svg": 70160,
	"./sway.svg": 55590,
	"./swift.svg": 13559,
	"./toit.svg": 9417,
	"./ts.svg": 87537,
	"./v.svg": 22572,
	"./vala.svg": 2656,
	"./vyper.svg": 9274,
	"./wasm.svg": 43854,
	"./zig.svg": 59212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20066;